import { goToStripe } from "./goToStripe";


export function loadPlans(){
    listeners()
}

function listeners(){
    $(".go-to-stripe").on("click", function(){
        goToStripe($(this))
    });
}